import { render } from "./index.vue?vue&type=template&id=7c10884d"
const script = {}
script.render = render

export default script